import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  query: '',
  results: [],
  interests: [],
  needs: [],
  district: '',
  suburb: '',
  breed: '',
  page: [],
  sort: [],
};

/**
 * search in state
 * Provides search results
 */
const search = handleActions(
  {
    SEARCH_RESULTS: (state, action) => Object.assign({}, state, action.payload),
    SAVE_SEARCH: (state, action) => Object.assign({}, state, action.payload),
    LOGOUT: INITIAL_STATE,
  },
  INITIAL_STATE,
);

export default search;



// WEBPACK FOOTER //
// ./src/reducers/search.js